var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-head'),(_vm.networkError)?_c('empty',{attrs:{"type":"network","height":"600px"}}):_vm._t("default"),_c('page-foot')],2)}
var staticRenderFns = []

export { render, staticRenderFns }